import { Method } from '@rxap/utilities';
import { OpenApiMethod, HttpMethods, BaseOpenApiMethod, OpenApiParameterType } from '../../open-api.method';
import { CartConstantsControllerGetResponse } from '../../responses/cart-constants-controller-get.response';
import { config } from '../../../config';

interface CartConstantsControllerGetOpenApiParameters {
  parameters: {
    tenantId: string;
  };
}

@OpenApiMethod({
  method: HttpMethods.GET,
  apiName: 'customer',
  path: '/cart-constants',
  operationId: 'CartConstantsController_get',
  parameters: [
    {
      name: 'tenantId',
      required: true,
      in: OpenApiParameterType.QUERY,
    },
  ],
})
export class CartConstantsControllerGetMethod
  extends BaseOpenApiMethod<CartConstantsControllerGetResponse>
  implements Method<CartConstantsControllerGetResponse, CartConstantsControllerGetOpenApiParameters>
{
  public call(): Promise<CartConstantsControllerGetResponse> {
    return super.call({
      parameters: {
        tenantId: config.tenantId,
      },
    });
  }
}
